module.exports = __webpack_public_path__ + "img/img4.e33ec010.svg";